var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{on:{"click":_vm.deneme}},[_vm._v("Buraya bas")])])
}
var staticRenderFns = []

export { render, staticRenderFns }